import { render } from "./CheckNonFatturati.vue?vue&type=template&id=64a8ea0f&scoped=true"
import script from "./CheckNonFatturati.vue?vue&type=script&lang=js"
export * from "./CheckNonFatturati.vue?vue&type=script&lang=js"

import "./CheckNonFatturati.vue?vue&type=style&index=0&id=64a8ea0f&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a8ea0f"]])

export default __exports__